import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import acc from 'accounting'
import {TopButtonPointAction} from "../../../../componentsTopsa/buttons/TopButtons";
import tabgrid from "../../../../utilities/TabGrid";
import TopExportCSV from "../../../../componentsTopsa/exportCSV/TopExportCSV";

export default class OrlenRaportTable extends Component {
    constructor(props) {
        super(props);
        this.state = {

            wszystkieKolumnyEksport: [
                {value: "numer_rej", label: 'Numer rejestracyjny'},
                {value: "licznik_od", label: 'Licznik od'},
                {value: "licznik_do", label: 'Licznik do'},
                {value: "dystans", label: 'Dystans'},
                {value: "nazwa_prod", label: 'Produkt'},
                {value: "jm", label: 'JM'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wartosc", label: 'Wartość'},

            ],
            kolumnyDoExportuDefault: [
                {value: "numer_rej", label: 'Numer rejestracyjny'},
                {value: "licznik_od", label: 'Licznik od'},
                {value: "licznik_do", label: 'Licznik do'},
                {value: "dystans", label: 'Dystans'},
                {value: "nazwa_prod", label: 'Produkt'},
                {value: "jm", label: 'JM'},
                {value: "ilosc", label: 'Ilość'},
                {value: "wartosc", label: 'Wartość'},
            ]

        };
        this.renderButtonyAkcji = this.renderButtonyAkcji.bind(this)
    }

    renderButtonyAkcji(cell, row) {
        return (
            <div>
                <TopButtonPointAction onClick={() => {
                }} buttonIcon={'fa fa-list'} buttonColor={'default'} titleContent={'Zobacz pozycje'}/>
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,  // Showing 30 for the size per page as default
            sizePerPageList: [10, 15, 30],
            noDataText: 'Brak pasujących rekordów',
        };
        return (
            <div>
                <div>
                    <TopExportCSV daneRest={this.props.data} wszystkieKolumny={this.state.wszystkieKolumnyEksport}
                                  kolumnyDoExportu={this.state.kolumnyDoExportuDefault}/>
                </div>
                <div className={'pull-right'} style={{fontSize: '12px', color: 'grey', padding: '5px', fontStyle: 'italic'}}>
                    Ilość wszystkich rekordów: {this.props.data.length}
                </div>
                <div>
                    <BootstrapTable data={this.props.data}
                                    options={options}
                                    pagination
                                    hover

                    >
                        <TableHeaderColumn dataField='wartosc' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='numer_rej' dataSort
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Numer rejestracji</TableHeaderColumn>
                        <TableHeaderColumn dataField='licznik_od' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Licznik od [km]</TableHeaderColumn>
                        <TableHeaderColumn dataField='licznik_do' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Licznik do [km]</TableHeaderColumn>
                        <TableHeaderColumn dataField='dystans' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Dystans [km]</TableHeaderColumn>
                        <TableHeaderColumn dataField='nazwa_prod' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >Produkt</TableHeaderColumn>
                        <TableHeaderColumn dataField='jm' dataSort
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                           filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                        >JM</TableHeaderColumn>
                        <TableHeaderColumn dataField='ilosc' dataSort
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               if (row.jm === 'SZT') return cell
                                               else return (cell).toFixed(2)
                                           }}
                        >Ilość</TableHeaderColumn>
                        <TableHeaderColumn dataField='wartosc' dataSort
                                           thStyle={tabgrid.tg4} tdStyle={tabgrid.tg4}
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={(cell, row) => {
                                               return acc.formatMoney(cell)
                                           }}
                        >Wartość</TableHeaderColumn>
                        {/*<TableHeaderColumn dataField='ID'
                                       thStyle={tabgrid.tg1} tdStyle={tabgrid.tg1}
                                       dataFormat={this.renderButtonyAkcji}
                    >Zobacz pozycje</TableHeaderColumn>*/}
                    </BootstrapTable>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/raporty/Orlen/components/OrlenRaportTable.js